export const SECURE_STORAGE_KEY = 'xhs_user_session'

export const PLATFORM_TABLE_MAP = {
  mobile_delta: {
    player: 'player',
    orders: 'orders',
    xianyu_order: 'xianyu_order',
    fines: 'fines',
    deposits: 'deposits',
    transfer_orders: 'transfer_orders'
  },
  pc_delta: {
    player: 'player_pc_delta',
    orders: 'orders_pc_delta',
    xianyu_order: 'xianyu_order_pc_delta',
    fines: 'fines_pc_delta',
    deposits: 'deposits_pc_delta',
    transfer_orders: 'transfer_orders_pc_delta'
  },
  wzry: {
    player: 'player_wzry',
    orders: 'orders_wzry',
    xianyu_order: 'xianyu_order_wzry',
    fines: 'fines_wzry',
    deposits: 'deposits_wzry',
    transfer_orders: 'transfer_orders_wzry'
  },
  hpjy: {
    player: 'player_hpjy',
    orders: 'orders_hpjy',
    xianyu_order: 'xianyu_order_hpjy',
    fines: 'fines_hpjy',
    deposits: 'deposits_hpjy',
    transfer_orders: 'transfer_orders_hpjy'
  }
}

export const PLATFORM_INFO = {
  mobile_delta: { name: '手游三角洲', icon: '📱' },
  pc_delta: { name: 'PC三角洲', icon: '💻' },
  wzry: { name: '王者荣耀', icon: '⚔️' },
  hpjy: { name: '和平精英', icon: '🎯' }
}

export function generateSessionId() {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
}

export function encryptData(data) {
  try {
    const jsonStr = JSON.stringify(data)
    return btoa(encodeURIComponent(jsonStr))
  } catch (error) {
    console.error('数据加密失败:', error)
    return null
  }
}

export function decryptData(encryptedData) {
  try {
    const jsonStr = decodeURIComponent(atob(encryptedData))
    return JSON.parse(jsonStr)
  } catch (error) {
    console.error('数据解密失败:', error)
    return null
  }
}

export function setSecureStorage(key, data, expiresInMinutes = 10080) {
  try {
    const item = {
      data: encryptData(data),
      expiresAt: Date.now() + (expiresInMinutes * 60 * 1000),
      sessionId: generateSessionId()
    }
    localStorage.setItem(key, JSON.stringify(item))
    return true
  } catch (error) {
    console.error('安全存储失败:', error)
    return false
  }
}

export function getSecureStorage(key) {
  try {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) return null
    
    const item = JSON.parse(itemStr)
    
    if (Date.now() > item.expiresAt) {
      localStorage.removeItem(key)
      return null
    }
    
    return decryptData(item.data)
  } catch (error) {
    console.error('安全读取失败:', error)
    localStorage.removeItem(key)
    return null
  }
}

export function removeSecureStorage(key) {
  localStorage.removeItem(key)
}

export function validatePassword(password) {
  if (!password || password.length < 6) {
    return { valid: false, message: '密码至少需要6个字符' }
  }
  
  const hasNumber = /\d/.test(password)
  const hasLetter = /[a-zA-Z]/.test(password)
  
  if (!hasNumber || !hasLetter) {
    return { valid: false, message: '密码需要包含数字和字母' }
  }
  
  return { valid: true, message: '密码强度符合要求' }
}

export function validateUsername(username) {
  if (!username || username.length < 1) {
    return { valid: false, message: '请输入用户名' }
  }
  
  if (username.length > 10) {
    return { valid: false, message: '用户名不能超过10个字符' }
  }
  
  return { valid: true, message: '用户名格式正确' }
}